export enum PaymentProcessEventType {
  INITIATE = "initiate",
  SAVE = "save",
  SAVE_ERROR = "save_error",
}

export type PaymentProcessEventListener = (data: {
  eventType: PaymentProcessEventType;
  paymentMethodType?: string;
}) => void;

export enum DefaultPaymentOption {
  CREDIT_OR_DEBIT_CARD = "CREDIT_OR_DEBIT_CARD",
  BANK_ACCOUNT = "BANK_ACCOUNT",
}

export enum AdyenPaymentMethodType {
  UNKNOWN = "UNKNOWN",
  CARD = "scheme",
  SEPA = "sepadirectdebit",
  IDEAL = "ideal",
  BACS = "directdebit_GB",

  // Linking new Sofort instrument is no longer supported
  SOFORT = "directEbanking",
}
